import {
  type MutateOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import type { QueryError } from '@/utils/errors';
import { createProfileQueryKey } from '@/utils/queryKeys';
import type {
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables,
} from './useUpdateOrganization.generated';

const query = gql`
  mutation UpdateOrganization($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      id
      name
      memberCount
      seatLimit
      role
      createdAt
    }
  }
`;

export const useUpdateOrganization = (organizationId: string) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation<
    UpdateOrganizationMutation,
    QueryError,
    UpdateOrganizationMutationVariables
  >({
    mutationFn: (variables) => {
      return gqlClient.request<
        UpdateOrganizationMutation,
        UpdateOrganizationMutationVariables
      >(query, variables);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: createProfileQueryKey(),
      });
    },
  });

  const updateName = (
    name: string,
    options?: MutateOptions<
      UpdateOrganizationMutation,
      QueryError,
      UpdateOrganizationMutationVariables
    >
  ) => mutate({ input: { organizationId, name } }, options);

  return {
    updateName,
    isPending,
  };
};
